import {Component} from 'react';

// Assets
import insta from '../../assets/whiteInsta.svg';
import fb from '../../assets/whiteFb.svg';
import yTube from '../../assets/whiteYTube.svg';
import lIn from '../../assets/whiteLinkedIn.svg';
import logo from '../../assets/logo.svg';

class Footer extends Component {

    render() {


        return (
            <div className='Footer'>
                <div className='Footer_ContentBlock'>
                    <div className='Footer_Block1'>
                        <div className='Footer_B1Title'>
                            SHARPERS
                        </div>
                        <div className='Footer_B1Desc'>
                            A leaading developers of A-grade commercial, industrial and residential projects in pune.
                            Since its foundation the company has double its turn over on year, with it staff members. 
                        </div>
                        <div className='Footer_B1Button'>
                            <button className='Footer_Button'></button>
                            Request a Quote
                        </div>
                    </div>
                    <div className='Footer_Block2'>
                        <div className='Footer_B2Title'>Links</div>
                        <ul className='Footer_B2Desc'>
                            <li>About Us</li>
                            <li>Meet Our Team</li>
                            <li>Media and News</li>
                            <li>Contacts</li>
                            <li>Careers</li>
                        </ul>
                    </div>
                    <div className='Footer_Block3'>
                        <div className='Footer_B3Title'>Quick Contact</div>
                        <div className='Footer_B3Address'>
                            Opp. Assian College, Pari Chowk, Narhe Gaon, Pune 411041, Maharashtra, India
                        </div>
                        <div className='Footer_B3Desc'>If you have any questions or need help feel free to contact with our team.</div>
                        <div className='Footer_B3Phone'>
                            <button className='Footer_PhoneBtn'></button>
                            (002)01061245741
                        </div>
                    </div>
                </div>
                <div className='Footer_BottomContent'>
                    <div className='Footer_LogoBlock'>
                        <div className='Footer_CopyRight'>© SHAPERS PTY LTD 2022. All rights reserved.</div>
                    </div>
                    <div className='Footer_Social'>
                        <img src={yTube}/>
                        <img src={fb}/>
                        <img src={insta}/>
                        <img src={lIn}/>
                    </div>
                </div>
            </div>
        );
    }
}

export default Footer;